import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CurrentMonth } from '../App';
import s from '../styles/App.module.css';

interface ProductCardProps {
    title: string;
    price: number;
    month: string;
    month_amount: number;
    isPopular?: boolean;
    features?: string[];
}

const ProductCard = ({ title, price, month, month_amount, isPopular, features }: ProductCardProps) => {
    const navigate = useNavigate();
    const currentMonth = useContext<any>(CurrentMonth);

    function OpenBuyPage() {
        currentMonth.setCurrentMonth(month_amount);
        navigate('/buy');
    }

    function NonSelected(e: React.MouseEvent) {
        e.stopPropagation();
        currentMonth.setCurrentMonth(0);
    }

    const formattedMonth = month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();

    const defaultFeatures = [
        'Доступен на:',
        'iOS',
        'Android',
        'macOS',
        'Linux',
        'Windows'
    ];

    const displayFeatures = features || defaultFeatures;
    
    const popular = isPopular !== undefined ? isPopular : month_amount === 90;
    const isSelected = currentMonth?.currentMonth === month_amount;

    return (
        <div className={`${s.card} ${popular ? s.card_popular : ''}`} onClick={OpenBuyPage}>
            {popular && <div className={s.card_badge}>ПОПУЛЯРНЫЙ</div>}
            
            <div className={s.card_header}>
                <p className={s.card_month}>{formattedMonth}</p>
                <div className={s.card_price_row}>
                    <span className={s.card_price}>{price} ₽</span>
                    <span className={s.card_permonth}>/ мес.</span>
                </div>
            </div>
            
            <div className={s.card_features}>
                <ul className={s.description}>
                    {displayFeatures.map((feat, index) => {
                        const isHeader = feat === 'Доступен на:';
                        
                        return (
                            <li key={index} style={isHeader ? { color: '#fff', fontWeight: 600, marginBottom: '2px' } : { paddingLeft: '8px' }}>
                                {!isHeader && (
                                    <svg className={s.check_icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                )}
                                {feat}
                            </li>
                        );
                    })}
                </ul>
            </div>
            
            <div className={s.card_footer}>
                {isSelected ? (
                    <button className={`${s.card_btn} ${s.card_btn_selected}`} onClick={NonSelected}>
                        В корзине
                    </button>
                ) : (
                    <button className={`${s.card_btn} ${popular ? s.card_btn_popular : ''}`} onClick={(e) => { e.stopPropagation(); OpenBuyPage(); }}>
                        Купить за {price} ₽
                    </button>
                )}
            </div>
        </div>
    );
};

export default ProductCard;